var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"root",staticClass:"ui-toggle-switcher",class:[{'disabled': _vm.disabled, 'checked': _vm.yesValue === _vm.innerValue}, _vm.type],attrs:{"tabindex":_vm.disabled? -1:0},on:{"focus":_vm.onGetFocus,"blur":_vm.onBlur,"click":_vm.toggle}},[_c('div',{staticClass:"slider"})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dfa2cd40","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/ui-toggle-switcher/src/ui-toggle-switcher.vue
// module id = 746
// module chunks = 0